// Exact loopback hosts, aligned with LOOPBACK_OAUTH_HOSTNAMES
// (desktop/oauth.ts): trailing-dot localhost and bracketed IPv6 included.
// URL.hostname is already lowercased by the WHATWG parser.
const LOCAL_SUPABASE_HOSTNAMES = new Set(['localhost', 'localhost.', '127.0.0.1', '[::1]']);

/**
 * Whether this build targets a Supabase instance on the developer's own
 * machine. Infrastructure-availability telemetry (e.g. a realtime channel
 * that persistently fails) against localhost describes the state of the
 * local docker stack (container down, `pp start` incomplete), never the
 * product — the same event against a hosted instance is a genuine signal
 * and must keep flowing.
 */
export function isLocalSupabaseTarget(
  url: string | undefined = (import.meta.env as Record<string, string | undefined>)
    .VITE_SUPABASE_URL,
): boolean {
  if (!url) {
    return false;
  }
  try {
    return LOCAL_SUPABASE_HOSTNAMES.has(new URL(url).hostname);
  } catch {
    return false;
  }
}
